import React from 'react';
import { IntroWidgetAnchor } from '@amzn/intro-widgets-api';

const FIT_INITIALIZATION_SCRIPT = 'fit-initialization';

type LaunchModalProps = {
  widgetId: string;
};

const LaunchModal: React.FC<LaunchModalProps> = ({ widgetId }) => {
  const domElement = document.querySelector(`#${FIT_INITIALIZATION_SCRIPT}`);
  if (!domElement || !domElement.innerHTML.includes(widgetId)) {
    return null;
  }

  return <IntroWidgetAnchor id={widgetId} />;
};

export default LaunchModal;
